var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleMobileSelectedKudzuplus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 26,
    rx: 13,
    fill: "#4378FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 13,
    r: 10,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleMobileSelectedKudzuplus);
export default __webpack_public_path__ + "static/media/Toggle_Mobile_Selected_Kudzuplus.04a471f23381828ff6bafdcf5f51f7cc.svg";
export { ForwardRef as ReactComponent };